import classNames from "classnames";
import React from "react";
import { ActionButton } from "./action-button";
import "./cta-footer.scss";
import { MailingList } from "./mailing-list";
import { TopWave } from "./top-wave";
import { SuperBlockContent } from "./block-content/super-block-content";

interface Props {
  title: string;
  header?: any;
  body?: any;
  buttons?: any;
}

export const Cta = ({ title, header, body, buttons }: Props) => {
  const noBg = true;
  return (
    <div className="cta">
      {!noBg && <TopWave type="dip" />}
      <div
        className={classNames("cta-footer--content", {
          "cta-footer--content--noBG": noBg,
        })}
      >
        <div>
          <SuperBlockContent
            projectId={"g3so7nt7"}
            dataset={"production"}
            className="block-body template--body cta-title"
            blocks={header}
          />
          <SuperBlockContent
            projectId={"g3so7nt7"}
            dataset={"production"}
            className="block-body template--body cta-mid"
            blocks={body}
          />
          <SuperBlockContent
            projectId={"g3so7nt7"}
            dataset={"production"}
            className="cta-footer--item"
            blocks={buttons}
          />
        </div>
      </div>
    </div>
  );
};
